/* Copyright (c) 2024 Dante Passalacqua */

const data = [
	{
		id: 9,
		title: 'Royal Gorge Route Railroad',
		description:
			'The Royal Gorge Route Railroad is a heritage railroad based in Cañon City, Colorado. A 1950s-era train makes daily 2-hour excursion runs from the Santa Fe Depot through the Royal Gorge along a famous section of the former Denver and Rio Grande Western Railroad.',
		coverImg: 'royal-gorge.jpg',
		dates: '16 Sept 2023',
		location: 'Colorado',
		maps: 'https://maps.app.goo.gl/TJAGLwxvw3hidJm3A',
	},
	{
		id: 8,
		title: 'Twin Lakes',
		description:
			'Twin Lakes is a pair of glacier-carved alpine lakes about 15 miles (24 km) south of historic Leadville, Colorado. They are downstream along the Arkansas River, whose headwaters are by Leadville. The lakes, however, are on a tributary, Lake Creek, which joins the Arkansas just below the lakes.',
		coverImg: 'twin-lakes.jpg',
		dates: '8 May 2023',
		location: 'Colorado',
		maps: 'https://goo.gl/maps/hQhrEb8iMyUcFcYD9',
	},
	{
		id: 7,
		title: 'Zion National Park',
		description:
			'Zion National Park is an American national park located in southwestern Utah near the town of Springdale. Located at the junction of the Colorado Plateau, Great Basin, and Mojave Desert regions, the park has a unique geography and a variety of life zones that allow for unusual plant and animal.',
		coverImg: 'zion.jpg',
		dates: '10 Oct 2022',
		location: 'Utah',
		maps: 'https://goo.gl/maps/hwQ8DcnpV5s1rN1C7',
	},
	{
		id: 6,
		title: 'Great Sand Dunes National Park',
		description:
			'Great Sand Dunes National Park and Preserve is an American national park that conserves an area of large sand dunes up to 750 feet (230 m) tall on the eastern edge of the San Luis Valley, and an adjacent national preserve in the Sangre de Cristo Range, in south-central Colorado, United States.',
		coverImg: 'sand-dunes.jpg',
		dates: '1 Oct 2022',
		location: 'Colorado',
		maps: 'https://goo.gl/maps/gqamfwQceVbS749W8',
	},
	{
		id: 5,
		title: 'Pikes Peak',
		description:
			'Pikes Peak is the highest summit of the southern Front Range of the Rocky Mountains, in North America. The ultra-prominent 14,115-foot (4,302 m) mountain is located in Pike National Forest. The town of Manitou Springs lies at its base. The summit is higher than any point in the United States east of its longitude.',
		coverImg: 'pikes-peak.jpg',
		dates: '19 Jun 2022',
		location: 'Colorado',
		maps: 'https://goo.gl/maps/CY6NWxjcFPwUeDYMA',
	},
	{
		id: 4,
		title: 'Mount Evans',
		description:
			'Mount Evans is the highest peak in the Front Range of the Rocky Mountains of North America. The prominent 14,271-foot (4,350 m) mountain is located 13.4 miles (21.6 km) from Idaho Springs in Clear Creek County, Colorado, United States, on the drainage divide between Arapaho National Forest and Pike National Forest.',
		coverImg: 'mt-evans.jpg',
		dates: '2 Oct 2021',
		location: 'Colorado',
		maps: 'https://goo.gl/maps/SccT1pxyPEPEceS9A',
	},
	{
		id: 3,
		title: 'Bear Lake',
		description:
			'Bear Lake is a natural freshwater lake on the Idaho-Utah border in the Western United States. About 109 square miles in size, it is split about equally between the two states. The lake has been called the "Caribbean of the Rockies" for its unique turquoise-blue color.',
		coverImg: 'bear-lake-id.jpg',
		dates: '9 Sep 2021',
		location: 'Idaho',
		maps: 'https://goo.gl/maps/retxzKEbmD6RJ8AX6',
	},
	{
		id: 2,
		title: 'Salt Lake City',
		description:
			'Salt Lake City is the capital and most populous city of the U.S. state of Utah. Salt Lake City has developed a strong tourist industry based primarily on skiing and outdoor recreation. It hosted the 2002 Winter Olympics.',
		coverImg: 'slc-ut.jpg',
		dates: '3 July 2021',
		location: 'Utah',
		maps: 'https://goo.gl/maps/S7yoQEEDAebmJHi97',
	},
	{
		id: 1,
		title: 'Estes Park',
		description:
			'Estes Park is a statutory town in Larimer County, Colorado, United States. A popular summer resort and the location of the headquarters for Rocky Mountain National Park, Estes Park lies along the Big Thompson River.',
		coverImg: 'estes-park.jpg',
		dates: '12 Feb 2021',
		location: 'Colorado',
		maps: 'https://goo.gl/maps/q8LiMRRQdmb8JnRAA',
	},
	{
		id: 0,
		title: 'Dallas',
		description:
			'Dallas is the most populous city in the Dallas-Fort Worth metroplex, the fourth-largest metropolitan area in the United States at 7.5 million people. Located in the North Texas region, the city of Dallas is the main core of the largest metropolitan area in the southern United States.',
		coverImg: 'dallas-tx.jpg',
		dates: '2 Aug 2019',
		location: 'Texas',
		maps: 'https://goo.gl/maps/UgcekFphLxWTHHkt6',
	},
];

export default data;
